export default "__VITE_ASSET__S2PAgKt3__";